import { Tag, Tooltip } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MoreMenu } from "datastake-daf/dist/components";

export default function useImpactPriorities() {
  const { t } = useTranslation();

  const columns = useMemo(() => [
    {
      dataIndex: 'datastakeId',
      title: t('AMP ID'),
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      dataIndex: 'name',
      title: t('Name'),
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      dataIndex: 'locationName',
      title: t('Location'),
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        return <Tooltip title={v}>{v || '--'}</Tooltip>;
      },
    },
    {
      dataIndex: 'status',
      title: t('Status'),
      width: 130,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        let config;

        switch (v) {
          case 'active':
            config = { label: 'Active', color: 'green' };
            break;
          case 'imp-complete':
            config = { label: 'IMP Complete', color: 'blue' };
            break;
          default:
            config = { label: 'Active', color: 'green' };
            break;
        }

        if (!config) {
          return '--';
        }

        return (
          <Tag color={config.color} style={{ width: 94 }}>
            {config.label}
          </Tag>
        )
      },
    },
    {
      dataIndex: 'investment',
      title: t('Investment'),
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        return <Tooltip title={v}>{v || '--'}</Tooltip>
      },
    },
    {
      dataIndex: 'repayment',
      title: t('Repayment'),
      width: 130,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        let config;

        switch (v) {
          case 'active':
            config = { label: 'Active', color: 'green' };
            break;
          case 'not-started':
            config = { label: 'Not Started', color: 'default' };
            break;
          default:
        }

        if (!config) {
          return '--';
        }

        return (
          <Tag color={config.color} style={{ width: 94 }}>
            {config.label}
          </Tag>
        )
      },
    },
    {
      dataIndex: 'esg',
      title: t('ESG'),
      width: 140,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        let config;

        switch (v) {
          case 'continuous':
            config = { label: 'Continuous', color: 'blue' };
            break;
          case 'pre-investment':
            config = { label: 'Pre-Investment', color: 'magenta' };
            break;
          case 'best-practice':
            config = { label: 'Best Practice', color: 'green' };
            break;
          default:
        }

        if (!config) {
          return '--';
        }

        return (
          <Tag color={config.color} style={{ width: 104 }}>
            {config.label}
          </Tag>
        )
      },
    },
    {
      dataIndex: 'equipment',
      title: t('Equipment '),
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        return <Tooltip title={v}>{v || '--'}</Tooltip>
      },
    },
    {
      dataIndex: 'action',
      title: '',
      width: 80,
      render: (_, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />
        }

        const items = [
          // { label: 'ESG Analysis', value: 'ESGAnalysis', disabled: true, }
        ];

        return (
          <MoreMenu items={items} />
        )
      }
    },
  ], [t]);

  return { columns };
}
